import { render } from "./ReCaptchaCheckbox.vue?vue&type=template&id=f9b06830&scoped=true&ts=true"
import script from "./ReCaptchaCheckbox.vue?vue&type=script&lang=ts"
export * from "./ReCaptchaCheckbox.vue?vue&type=script&lang=ts"

import "./ReCaptchaCheckbox.vue?vue&type=style&index=0&id=f9b06830&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b06830"]])

export default __exports__